import { Controller } from '@hotwired/stimulus'
import 'altcha'
import { stimulus } from '~/init'

class AltchaController extends Controller {
  static targets = ['widget']

  connect () {
    document.addEventListener('turbo:morph', this.#onMorph)
  }

  disconnect () {
    document.removeEventListener('turbo:morph', this.#onMorph)
  }

  // One reference for add and remove: a fresh `bind` in disconnect removes
  // nothing and leaks a handler per visit.
  #onMorph = () => this.#reload()

  #reload () {
    window.requestAnimationFrame(() => {
      if (this.hasWidgetTarget && typeof this.widgetTarget.reset === 'function') {
        this.widgetTarget.reset()
      }
    })
  }
}

stimulus.register('altcha', AltchaController)
